// extracted by mini-css-extract-plugin
export default {"mobileMessage":"Statistiques_mobileMessage__aghqf","tableau":"Statistiques_tableau__IsmE3"};